import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnUserList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import { capitalizeFirstLetter } from 'src/helpers/text-format'
import useToastMessage from 'src/helpers/toast-message'

const UserList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();
  const user = JSON.parse(localStorage.getItem('user'))

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [userList, setUserList] = useState([]);
  const [userListCount, setUserListCount] = useState(0);
  const [userListPerPage, setUserListPerPage] = useState(10);
  const [activeUserListPage, setActiveUserListPage] = useState(1);
  const [searchUserListFilter, setSearchUserListFilter] = useState("");
  const [columnUserListSorter, setColumnUserListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchUserListFilter,
      limit: userListPerPage,
      offset: userListPerPage * activeUserListPage - userListPerPage,
      sort:
        (columnUserListSorter &&
          `${columnUserListSorter.column}%${columnUserListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllUsers(queries);
  }, [
    searchUserListFilter,
    userListPerPage,
    activeUserListPage,
    columnUserListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveUserListPage(1)
    setSearchUserListFilter(search);
  }

  const fetchAllUsers = (queries) => {
    Axios({
      method: "get",
      url: `/api/sso/v1/users/list/count?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let tempUserList = data?.value?.filter((d) => d?.id !== user?.id)
          tempUserList = tempUserList?.map((d) => ({
            ...d,
            name: d?.profile ? d?.profile?.last_name ? `${capitalizeFirstLetter(d?.profile?.first_name)} ${capitalizeFirstLetter(d?.profile?.last_name)}` : capitalizeFirstLetter(d?.profile?.first_name) : d?.username,
            is_active: d?.is_active ? 'Active' : 'Inactive',
            contact_number: d?.profile?.country ? `${d?.profile?.country?.phone_code}${d?.profile?.phone_number}` : '-',
            role: d?.roles ? d?.roles[0]?.title : '-'
          }))
          setUserList(tempUserList);
          if (activeUserListPage === 1) {
            setUserListCount(data?.count);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/sso/v1/users/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllUsers()
          showSuccess('User has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/user/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`User ${showConfirmDelete?.item?.profile?.first_name ? showConfirmDelete?.item?.profile?.first_name : showConfirmDelete?.item?.username}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/user/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add User
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>User List</h4>}
        bodyContent={
          <AppTable
            userListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnUserList}
            tableContent={userList}
            contentPerPage={userListPerPage}
            activeContentPage={activeUserListPage}
            contentCount={userListCount}
            searchContentFilter={searchUserListFilter}
            setActiveContentPage={setActiveUserListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setUserListPerPage}
            setColumnContentSorter={setColumnUserListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default UserList